import {useDispatch, useSelector} from "react-redux";
import {FIELD_LIST_SHOP_BY_CATEGORY_ITEM} from "../../../utils/input-field-list-static-page";
import {convertErrorMessage, randomCode} from "../../../utils/general-variable";
import React, {useEffect} from "react";
import {
    setMainPageErrorMessage,
    setMainPageShopByCategoryDetail,
} from "../../../reducers/main-page.reducer";
import {useFetch} from "../../../services/useFetch";
import {API} from "../../../services/api";
import {cloneDeep} from "lodash";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../../reducers/tools.reducer";
import FormItemComponent from "../../../components/static-page/form-item.component";
import ItemCategory from "./item-category";

const ShopByCategory = () => {
    const dispatch = useDispatch()
    const {shopByCategoryDetail} = useSelector(state => state.mainPageReducer)
    const {fetching: getShopByCategory} = useFetch(API.HOMEPAGE_GET_SHOP_BY_CATEGORY)
    const {fetching: updateShopByCategory, isLoading} = useFetch(API.HOMEPAGE_UPDATE_SHOP_BY_CATEGORY)
    const itemList = [...shopByCategoryDetail.item_list]
    let fieldList = FIELD_LIST_SHOP_BY_CATEGORY_ITEM
    let showShopByCategory = {
        label: 'Shop By Category',
        key: 'show_shop_by_category',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setMainPageShopByCategoryDetail({[key]: value}))
    }

    const addItemHandler = () => {
        itemList.push({
            id: randomCode(5, 1, 'shop_by_category').toString(),
            product_image: null,
            title: null,
            link_product: null
        })
        dispatch(setMainPageShopByCategoryDetail({item_list: itemList}))
    }

    const itemListConstruct = () => {
        const itemListCopy = cloneDeep(shopByCategoryDetail.item_list)
        const result = itemListCopy?.map((item, index) => {
            if (!Number(item.id)) delete item.id
            item.sequence = index
            return item
        })
        return result
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        const dataItemList = itemListConstruct()
        const dataShopByCategory = {...shopByCategoryDetail, item_list: dataItemList}
        updateShopByCategory(dataShopByCategory).then(response => {
            dispatch(setMainPageErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Shop By Category Updated'))
            dispatch(setMainPageShopByCategoryDetail({...response?.data, delete_item: []}))
        }).catch(err => {
            dispatch(setMainPageErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getShopByCategory().then(response => {
            if (response?.data?.item_list?.length > 0) {
                dispatch(setMainPageShopByCategoryDetail({...response?.data, delete_item: []}))
            } else {
                const data = response?.data
                delete data?.item_list
                dispatch(setMainPageShopByCategoryDetail({...data, delete_item: []}))
            }
        })

        return () => {
            dispatch(setMainPageErrorMessage({}))
        }
    }, [])

    return (
        <FormItemComponent
            data={shopByCategoryDetail}
            title={'Category'}
            switchToggleField={showShopByCategory}
            itemList={itemList}
            content={(index) => <ItemCategory fieldList={fieldList} index={index}/>}
            onChange={onChange}
            setDataList={setMainPageShopByCategoryDetail}
            deleteList={shopByCategoryDetail.delete_item}
            objectDeleteName={'delete_item'}
            addItemHandler={addItemHandler}
            onSubmitHandler={onSubmitHandler}
            isLoading={isLoading}
        />
    )
}

export default ShopByCategory
